<template>
  <div class="not-found">
    <img src="/imgs/chara/leo_404.png" alt="404 Not Found" />
    <div class="msg-box">
      <h1 class="title">404</h1>
      <p class="sub-title">페이지를 찾을 수 없습니다.</p>
      <p class="sub-title">요청하신 페이지는 존재하지 않거나, 삭제된 페이지입니다.</p>
      <p class="sub-title">다른 메뉴를 이용해 주세요.</p>
    </div>
    <button class="btn" @click="$router.push('/')">홈으로</button>
  </div>
</template>

<style scoped>
.not-found {
  width: 100%;
  height: 100vh;
  margin:0;
  padding: 0;
  box-sizing: border-box;
  background: var(--base-color);
  line-height: 1.2;
  text-align: center;
  font-family: "Oswald", sans-serif;
  padding: 80px 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap:var(--size-bigbig);
}

.not-found img {
  max-width: 50%;
  max-width: 480px;
  height: auto;
  aspect-ratio: 1/1;
  object-fit: cover;
}


.not-found .msg-box {
  color: var(--text-color);
  font-size: var(--size-bigbig);
  font-weight: 600;
}
.not-found .msg-box .title {
  font-size: var(--size-bigbig);
  font-weight: 600;
  color: var(--text-color);
}
.not-found .msg-box .sub-title {
  font-size: var(--size-big);
  font-weight: 400;
  color: var(--text-color);
}
.not-found .btn {
  padding: 12px 24px;
  font-size: var(--size-big);
  font-weight: 600;
  background: var(--brand-color);
  color: var(--base-color);
  border-radius: var(--size-bigbig);
  border: none;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}

.not-found .btn:active {
  transform: scale(0.95);
  background: var(--brand-color);
  color: var(--base-color);
}
</style>